import ReturnType from './ReturnType';
import { getElement } from './MultyElementsTemplate';

export default class ReturnSingleType extends ReturnType {
  outputTemplate = (attr, htmlElement, attachedAttribute) => {
    if (this.returnAttributeType(attr) === 'image') {
      return `
      if(response.body.query.${attr} !== undefined){
        if(document.querySelector('[annotationname = ${attr}]').getAttribute('type') === 'file'){
          document.querySelector('[annotationname = ${attr}]').setAttribute('data-image-base64',response.body.query.${attr}.data);
          let fileName = response.body.query.${attr}.name;
          let file = new File([response.body.query.${attr}.data], fileName,{lastModified:new Date().getTime()}, 'utf-8');
          let container = new DataTransfer();
          container.items.add(file);

          document.querySelector("[annotationname = ${attr}]").files = container.files;
        }
        else {
          document.querySelector('[annotationname = ${attr}]').src = response.body.query.${attr}.data ;
        }
        document.querySelector('[annotationname = ${attr}]').name = response.body.query.${attr}.name ;
      }
      `;
    }

    if (this.returnAttributeType(attr) === 'date') {
      return `if (response.body.query.${attr}) {const ${attr}IsoFormat =new Date(response.body.query.${attr}); document.querySelector('[annotationname = ${attr}]').${htmlElement} = ${attr}IsoFormat.getDate()+'-'+${attr}IsoFormat.getMonth()+'-'+${attr}IsoFormat.getFullYear();} else document.querySelector('[annotationname = ${attr}]').${htmlElement}='';`;
    }
    if (this.returnAttributeType(attr) === 'radiobox')
      return `if (response.body.query.${attr}) {document.querySelector('[annotationname = ${attr}][value = '+response.body.query.${attr}+']').checked = true;} else {document.querySelector('[annotationname = ${attr}]:checked').checked = false;}`;
    

    if (this.returnAttributeType(attr) === 'entity') {
      return `document.querySelector('[annotationname = ${attr}]').setAttribute('selected-element',response.body.query.${attr}.${attachedAttribute});${this.templateAdvanceSelectAlignEventTemplate(
        attr
      )}`;
    }
    return `document.querySelector('[annotationname = ${attr}]').${htmlElement} = response.body.query.${attr};`;
  };

  effectingHtmlElements = [];

  attachedAttributes = [];

  attributeArray = [];
  complexHtmlElement;
  complexHtmlElementArray;

  elementTemplate;

  singleType = true;

  templateAdvanceSelectAlignEventTemplate = (attr) => `<advanceSelectAlignEvent+${attr}>`;

  dispatchEventsNames = new Map();

  constructor(htmlDom, attributeArray, annotations, complexMethodId) {
    super(annotations);
    this.attributeArray = attributeArray || [];
    this.effectingHtmlElements = this.getTheHtmlElements(this.attributeArray, htmlDom) || {};
    this.attachedAttributes = this.getTheAttachedAttributes(this.attributeArray, htmlDom || {});
    this.elementTemplate = getElement('general');
    this.complexHtmlElementArray = [htmlDom.getElementById(complexMethodId)] || [];
    this.complexHtmlElement = htmlDom.getElementById(complexMethodId);
    this.dispatchEventsNames = [...htmlDom.querySelectorAll('[advance-select]')].reduce(
      (mapAttrEvents, selectElement) => {
        mapAttrEvents.set(selectElement.getAttribute('annotationname'), {
          command: `document.dispatchEvent(new Event("align${selectElement.getAttribute(
            'annotationname'
          )}"));`,
          template: this.templateAdvanceSelectAlignEventTemplate(
            selectElement.getAttribute('annotationname')
          )
        });
        return mapAttrEvents;
      },
      new Map()
    );
  }

  getTheHtmlElements(attributeArray, htmlDom) {
    return attributeArray.reduce((obj, attribute) => {
      const htmlTag =
        htmlDom.querySelector(`[annotationname = '${attribute}']`)?.tagName.toLowerCase() || '';
      const htmlAttr = this.htmlTagsToAttributes.get(htmlTag) || '';
      if (!htmlAttr) return { ...obj };
      return { ...obj, [attribute]: htmlAttr };
    }, {});
  }

  getTheAttachedAttributes(attributeArray, htmlDom) {
    return attributeArray.reduce((obj, attribute) => {
      const attachedAttributeElement =
        htmlDom.querySelector(`[annotationname ='${attribute}'][attached-subentity-attr]`) || '';
      if (!attachedAttributeElement) return { ...obj };
      const attachedAttribute = attachedAttributeElement.getAttribute('attached-subentity-attr');
      return { ...obj, [attribute]: attachedAttribute };
    }, {});
  }

  printFunctionality() {
    let js = '';
    const uniqueQueries = new Set([...this.gatherComplexQueries()]);
    const existsEntity = this.attributeArray
      .filter((attr) => this.returnAttributeType(attr) === 'entity')
      .map(() => true)[0];
    const tryAndCatch = [...uniqueQueries]
      .map((queryCommand) => this.tryCatchTemplate(queryCommand))
      .reduce((acc, command) => acc + command, '');
    if (existsEntity === true) {
      js += this.newMapTemplate();
    }
    js += tryAndCatch;

    if (existsEntity === true) {
      js += this.storeMapInLocalStorage();
    }

    if (!this.dispatchEventsNames.lenght) {
      [...this.dispatchEventsNames].forEach((eventObject) => {
        js = js.replace(eventObject[1].template, eventObject[1].command);
      });
    }

    js = js.replace(/<advanceSelectAlignEvent\+.*>/g, '');
    return js;
  }
}
